import * as React from "react";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";
import { ContentPageTheme } from "@/services/bedrock/dtos/ContentPageTheme";

export interface ThemePickerPopoverProps {
  themes: ContentPageTheme[];
  selectedId: number | null;
  defaultThemeId: number | null;
  onSelect: (themeId: number) => void;
}

/** The body of the theme popover: one row per theme, the player's default marked and the current one checked. */
export const ThemePickerPopover: React.FC<ThemePickerPopoverProps> = ({
  themes,
  selectedId,
  defaultThemeId,
  onSelect,
}) => (
  <div className="flex flex-col gap-1" data-testid="theme-picker">
    <div className="px-2 pt-1 pb-2 text-sm font-semibold text-slate-800">Choose a brand style</div>
    <ul className="flex max-h-72 flex-col gap-0.5 overflow-y-auto">
      {themes.map(theme => {
        const selected = theme.id === selectedId;
        return (
          <li key={theme.id}>
            <button
              type="button"
              onClick={() => onSelect(theme.id)}
              aria-pressed={selected}
              className={cn(
                "flex w-full items-center gap-2 rounded-lg px-2 py-1.5 text-left text-sm hover:bg-slate-50 cursor-pointer",
                selected && "bg-slate-50"
              )}
            >
              <span
                className="size-4 shrink-0 rounded-full border border-slate-200"
                style={{ backgroundColor: theme.primaryCtaColor || theme.backgroundColor }}
              />
              <span className="flex-1 truncate text-slate-700">{theme.name}</span>
              {theme.id === defaultThemeId && <span className="text-xs text-slate-400">Your default</span>}
              {selected && <Check className="size-4 text-primary" />}
            </button>
          </li>
        );
      })}
    </ul>
  </div>
);
